import { I18n } from '@aws-amplify/core';
import { SimplePageHeader, ReloadButton } from '@flexinet/ui-components';
import { Box } from '@mantine/core';
import { useQueryClient } from '@tanstack/react-query';

const ComponentsReloadButton = () => {
    const queryClient = useQueryClient();
    
    const handleReload = () => {
        queryClient.invalidateQueries({ queryKey: ['subscriptions'] });
        queryClient.invalidateQueries({ queryKey: ['products'] });
        queryClient.invalidateQueries({ queryKey: ['prices'] });
    };
    
    return (
        <Box mx='s'>
            <ReloadButton onClick={handleReload}/>
        </Box>
    );
};

const useTools = () => {
    const tools = [<ComponentsReloadButton key='reload'/>];
    return tools;
};

export const IndexPageHeader = () => {
    return (
        <SimplePageHeader
            title={I18n.get('My Products')}
            tools={useTools()}
        />
    );
};


